import React from 'react';
import { Link } from 'react-router-dom';

const SidebarComponent: React.FC = () => {
  return (
    <>
      {/* Our Services Section */}
      <div className="mb-5 wow fadeIn" data-wow-delay="0.1s"
        style={{visibility: "visible", animationDelay: "0.1s", animationName: "fadeIn"}}>
        <div className="section-header text-start pb-4">
          <h6 className="h4 fw-bold bg-white px-2 text-uppercase mb-0">Our Services</h6>
        </div>
        <div className="service-list d-flex flex-column border-start border-5 border-primary">
          <Link className="h6 fw-semi-bold bg-light p-3 mb-1" to="/water-treatment-plants">Water Treatment Plants</Link>
          <Link className="h6 fw-semi-bold bg-light p-3 mb-1" to="/sanyol-wt-specility-chemicals">SANYOL® WT Specialty Chemicals</Link>
          <Link className="h6 fw-semi-bold bg-light p-3 mb-1" to="/design-and-consultancy">Design & Engineering Consultancy</Link>
          <Link className="h6 fw-semi-bold bg-light p-3 mb-1" to="/operation-and-maintenance">Operation & Maintenance</Link>
          <Link className="h6 fw-semi-bold bg-light p-3 mb-1" to="/revamping-of-water-treatment-plants"> Revamping of Water Treatment
            Plants</Link>
          <Link className="h6 fw-semi-bold bg-light p-3 mb-1" to="/wastewater-treatment-solutions">Wastewater Treatment solutions </Link>
          <Link className="h6 fw-semi-bold bg-light p-3 mb-1" to="/heavy-industries">Heavy Industries</Link>
        </div>
      </div>
      
      {/* Download Section */}
      <div className="mb-5 wow fadeIn" data-wow-delay="0.1s"
        style={{visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp"}}>
        <div className="section-header text-start pb-4">
          <h6 className="h4 fw-bold bg-white px-2 text-uppercase mb-0">Download</h6>
        </div>
        <div className="d-flex flex-column">
          <Link className="btn btn-primary fw-semi-bold py-3 mb-3" to="/downloads/brochure.pdf" target="_blank" rel="noopener noreferrer"><i
            className="fa fa-download me-2"></i>Download Brochure (PDF)</Link>
          <Link className="btn btn-primary fw-semi-bold py-3" to="/downloads/brochure.png" target="_blank" rel="noopener noreferrer"><i
            className="fa fa-download me-2"></i>Download Brochure (PNG)</Link>
        </div>
      </div>
      
      {/* Contact Detail Section */}
      <div className="wow fadeIn" data-wow-delay="0.1s"
        style={{visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp"}}>
        <div className="section-header text-start pb-4">
          <h6 className="h4 fw-bold bg-white px-2 text-uppercase mb-0">Contact Detail</h6>
        </div>
        <div className="bg-dark p-4">
          <div className="d-flex align-items-center mb-4 wow fadeInUp" data-wow-delay="0.1s"
            style={{visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp"}}>
            <div className="bg-primary d-flex align-items-center justify-content-center"
              style={{width: "45px", height: "45px"}}>
              <i className="fa fa-phone-alt text-dark"></i>
            </div>
            <div className="ps-3">
              <p className="text-white mb-1">+012 345 6789</p>
              <p className="text-white mb-0">+012 345 6789</p>
            </div>
          </div>
          <div className="d-flex align-items-center mb-4 wow fadeInUp" data-wow-delay="0.1s"
            style={{visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp"}}>
            <div className="bg-primary d-flex align-items-center justify-content-center"
              style={{width: "45px", height: "45px"}}>
              <i className="fa fa-envelope text-dark"></i>
            </div>
            <div className="ps-3">
              <p className="text-white mb-1">wassertechnochem@hotmail.com</p>
              <p className="text-white mb-0">info@wassertechnochem.com</p>
            </div>
          </div>
          <div className="d-flex align-items-center wow fadeInUp" data-wow-delay="0.1s"
            style={{visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp"}}>
            <div className="bg-primary d-flex align-items-center justify-content-center"
              style={{width: "45px", height: "45px"}}>
              <i className="fa fa-map-marker-alt text-dark"></i>
            </div>
            <div className="ps-3">
              <p className="text-white mb-1">G-219, RIICO Industrial Area</p>
              <p className="text-white mb-0">Palra, Ajmer</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SidebarComponent;
